var $f50b102eda1268a7$exports = {};
const $f50b102eda1268a7$var$mon_p = document.createElement("p");
(async ()=>{
    $f50b102eda1268a7$var$mon_p.textContent = await (async ()=>{
        const fetch_promise = await fetch(`${"https://hugoat.pro/src/server"}/index.php`);
        let textContent_fetched = await fetch_promise.text();
        return textContent_fetched;
    })();
    console.log("mon_p.textContent : " + $f50b102eda1268a7$var$mon_p.textContent);
})();
document.querySelector("body").appendChild($f50b102eda1268a7$var$mon_p);


//# sourceMappingURL=client.49e73c2e.js.map
